import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.shared.visit-settlement': {
         serviceIsCurrentlyUnavailable: 'Usługa MUP jest w tej chwili niedostępna.',
         statusDescription: {
            SETTLED_CORRECTLY: 'Płatność rozliczona',
            SETTLED_INCORRECTLY: 'Płatność rozliczona nieprawidłowo',
            SETTLED_WITHOUT_MEDICAL_SERVICES: 'Płatność rozliczona bez usług',
            UNSETTLED: 'Płatność nierozliczona',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.shared.visit-settlement');
